import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LinearGradient from '@hfe/max-linear-gradient';
import { venusParams } from '../../utils/formatImage';
import { Free_Travel_TAG, GROUP_TOUR_TAG, DISCOUNT, CURVE } from '../../utils/constants';
import { formatPrice } from '../../utils/formatPrice';
import { jumpToDetail } from '../../utils/jumpUtils';
import { useEffect, createElement } from '@max/max';
const isMRN = false;
import { getSystemInfoSync } from '@max/meituan-uni-system';
import './doublecardstyle.scss';
const DoubleCard = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { goodInfo, index, supplyGroupId, pageSourceType, _LXReport } = props;
    const { platform } = getSystemInfoSync() || {};
    const isAndroid = platform === 'android';
    const { mvReport, mcReport } = _LXReport;
    const jumpDetail = () => {
        jumpToDetail({
            goodInfo,
            index,
            supplyGroupId,
            pageSourceType,
            mcReport
        });
    };
    const handleView = () => {
        mvReport('b_daodian_lowcode_7s2beos5_mv', {
            valLab: {
                deal_id: goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsId,
                biz_line: 'holiday',
                dealgroup_id: supplyGroupId,
                item_index: index
            }
        });
    };
    // 格式化促销金额，处理异常格式如 ' .00 '
    const formatPromotionAmount = (amount) => {
        if (!amount)
            return '0';
        // 如果是字符串，先去除空格
        const cleanAmount = typeof amount === 'string' ? amount.trim() : amount;
        // 处理以点开头的情况，如 '.00'
        const normalizedAmount = String(cleanAmount).replace(/^\s*\./, '0.');
        // 转换为数字
        const numAmount = Number(normalizedAmount);
        // 如果是非法数字，返回0
        if (isNaN(numAmount))
            return '0';
        // 如果是整数，直接返回
        if (Number.isInteger(numAmount))
            return String(numAmount);
        // 保留两位小数，去除末尾的0
        return numAmount.toFixed(2).replace(/\.?0+$/, '');
    };
    useEffect(() => {
        handleView();
    }, []);
    const actualPrice = (_b = (_a = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _a === void 0 ? void 0 : _a.payPrice) !== null && _b !== void 0 ? _b : goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.sellPrice;
    const categoryTagKey = (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? 3 : 2;
    const categoryTag = (_d = (_c = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _c === void 0 ? void 0 : _c.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === categoryTagKey)) === null || _d === void 0 ? void 0 : _d.descriptions;
    const productTag = (_f = (_e = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.tags) === null || _e === void 0 ? void 0 : _e.find((item) => (item === null || item === void 0 ? void 0 : item.tagKey) === 1)) === null || _f === void 0 ? void 0 : _f.descriptions;
    const showProductTag = (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.length) > 0 ? productTag === null || productTag === void 0 ? void 0 : productTag.slice(0, 3) : productTag;
    return <View className="double-card-container-double" onClick={() => {
        jumpDetail();
    }}>
      <View className="double-card-image-view">
        <Image className="double-card-image" source={{
        uri: venusParams(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsHeadPhoto, 345, 258)
    }}/>
      </View>
      <Image className="double-card-image-tag" source={{
        uri: (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' ? GROUP_TOUR_TAG : Free_Travel_TAG
    }}/>
      {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.departures) && goodInfo.departures.length > 0 && <View className="double-departures-container">
          <LinearGradient className="double-departures-background" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }} colors={['rgba(51, 51, 51, 0.6)', 'rgba(51, 51, 51, 0.6)']} style={{
        borderBottomRightRadius: 10
    }}/>
          <Text className="double-departures-text">
            {goodInfo.departures.length > 1 ? '多地出发' : `${((_g = goodInfo.departures[0]) === null || _g === void 0 ? void 0 : _g.cityName) || 'X X '}出发`}
          </Text>
        </View>}
      <View className="double-card-content-right">
        <View className="double-card-top-field">
          <View className="double-card-tag-field">
            
            <View className="double-card-deal-name">
              <View className="double-card-day-h5-tag-view" style={{
        top: isMRN ? '6rpx' : '5rpx'
    }}>
                <Text className="double-card-day-h5-tag-text">{goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.travelDay}</Text>
              </View>
              <Text className="double-card-deal-name-text" numberOfLines={2}>
                {isMRN ? '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0' : '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}
                {goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.goodsName}
              </Text>
            </View>
          </View>
          <View className="double-card-tag">
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) === '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="double-card-product-tag-group">
                    <Text className="double-card-product-tag-text-group">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (categoryTag === null || categoryTag === void 0 ? void 0 : categoryTag.map((item) => {
        return <View className="double-card-people-tag">
                    <Text className="double-card-people-tag-text">{item}</Text>
                  </View>;
    }))}
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.categoryName) !== '跟团游' && (showProductTag === null || showProductTag === void 0 ? void 0 : showProductTag.map((item) => {
        return <View className="double-card-product-tag-free">
                    <Text className="double-card-product-tag-text-free">{item}</Text>
                  </View>;
    }))}
          </View>
        </View>

        <View className="double-card-bottom-field">
          <View className="double-card-bottom-left-field">
            <View className="double-card-price-now" style={{
        marginBottom: isAndroid ? '3rpx' : '0rpx'
    }}>
              <Text className="double-card-price-icon">¥</Text>
              <Text className="double-card-price-price" style={{
        marginBottom: isAndroid ? '-2rpx' : '-5rpx',
        fontFamily: isMRN ? 'MTNewDigitalDisplay-Bold' : 'MTNewDigitalDisplay-Regular'
    }}>{formatPrice(actualPrice)}</Text>
              <Text className="double-card-price-start">起</Text>
              {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice) !== actualPrice && <Text className="double-card-price-origin">{`¥${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.marketPrice)}`}</Text>}
            </View>
            {(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount) > 0 && <View className="double-card-discount-width-field">
                {((_h = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _h === void 0 ? void 0 : _h.promotionAmount) && ((_j = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _j === void 0 ? void 0 : _j.promotionAmount) !== '.00' && Number((_k = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _k === void 0 ? void 0 : _k.promotionAmount) > 0 ? <>
                    <LinearGradient className="double-card-discount-left-field" start={{
        x: 0,
        y: 1
    }} end={{
        x: 0.5,
        y: 0
    }} colors={['#FF7700', '#FF4B10']}>
                      <Image className="double-card-discount-img" source={{
        uri: DISCOUNT
    }}/>
                      <Text className="double-card-discount-width-text">{`${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount)}折起`}</Text>
                    </LinearGradient>
                    <View className="double-card-discount-right-field">
                      <Image className="double-card-curve-img" source={{
        uri: CURVE
    }}/>
                      <Text className="double-card-reduce-text">{`共省¥${formatPromotionAmount((_l = goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.promotionPriceDTO) === null || _l === void 0 ? void 0 : _l.promotionAmount)}`}</Text>
                    </View>
                  </> : <LinearGradient className="double-card-discount-left-field" start={{
        x: 0,
        y: 1
    }} end={{
        x: 0.5,
        y: 0
    }} colors={['#FF7700', '#FF4B10']} style={{
        paddingRight: '5rpx',
        borderRadius: '6rpx'
    }}>
                    <Image className="double-card-discount-img" source={{
        uri: DISCOUNT
    }}/>
                    <Text className="double-card-discount-width-text">{`${formatPrice(goodInfo === null || goodInfo === void 0 ? void 0 : goodInfo.discount)}折起`}</Text>
                  </LinearGradient>}
              </View>}
          </View>
          <View className="double-card-bottom-right-field">
            <LinearGradient start={{
        x: 0.067,
        y: 0.75
    }} end={{
        x: 0.933,
        y: 0.25
    }} colors={['#FF7700', '#FF4B10']} style={{
        height: '60rpx',
        width: '104rpx',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }}>
              <Text className="double-card-bottom-right-text">{'抢购'}</Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </View>;
};
export default DoubleCard;
